<template>
    <div>
        <div class="com-page-title">
            <div class="inner">{{ $route.meta.title }}</div>
        </div>
        <div class="com-card">
            <div class="com-card-title">{{ $getSpecialReligiousAssemblyRecord([361]).includes(payload.id) ? '求授五戒者信息' : '求授皈依者信息' }}</div>
            <div class="com-card-content">
                <div class="com-form-wrap">
                    <van-form class="com-form-vertical" ref="form">
                        <van-field
                            v-model="form.name"
                            :border="false"
                            label="姓名"
                            placeholder="示例：XXX"
                            :rules="[{ required: true, trigger: 'onBlur', message: '请填写姓名' }]"
                        >
                            <template #left-icon>限一人，多人请分开报名</template>
                        </van-field>
                        <van-field
                            v-model="form.legalName"
                            :border="false"
                            label="法名"
                            placeholder="示例：XXX"
                            :rules="[{ required: true, trigger: 'onBlur', message: '请填写法名' }]"
                        />
                        <van-field
                            class="no-input"
                            :border="false"
                            label="性别"
                            :rules="[{ required: true, trigger: 'onChange', message: '请选择性别' }]"
                        >
                            <template #input>
                                <van-radio-group v-model="form.sex" direction="horizontal">
                                <van-radio name="男">男</van-radio>
                                <van-radio name="女">女</van-radio>
                                </van-radio-group>
                            </template>
                        </van-field>
                        <van-field
                            v-model="form.age"
                            :border="false"
                            label="年龄（周岁）"
                            placeholder="请填写实际年龄"
                            :rules="[{ required: true, trigger: 'onBlur', message: '请填写实际年龄' }]"
                        />
                        <van-field
                            v-model="form.idCartNum"
                            :border="false"
                            label="身份证号"
                            placeholder="请填写身份证号"
                            :rules="[{ required: true, trigger: 'onBlur', message: '请填写身份证号' }, { validator: $validate.idCard, message: '请填写正确的身份证号' }]"
                        />
                        <van-field
                            v-model="form.address"
                            :border="false"
                            label="户籍地址/现住址"
                            placeholder="请填写户籍地址或现住址"
                            :rules="[{ required: true, trigger: 'onBlur', message: '请填写户籍地址或现住址' }]"
                        />
                        <van-field
                            v-model="form.mobile"
                            :border="false"
                            label="联系方式"
                            placeholder="请填写手机号码"
                            :rules="[{ required: true, trigger: 'onBlur', message: '请填写手机号码' }, { validator: $validate.phone, message: '手机号格式不正确' }]"
                        />
                    </van-form>
                </div>
            </div>
        </div>
        <div class="com-card">
            <!-- <div class="com-card-title">合计</div> -->
            <div class="com-card-content">
                <!-- <div class="text-wrap">
                    <p class="t2">¥{{ payload.price }}</p>
                </div> -->
                <div class="com-form-submit">
                    <DefaultBtn @click="onPay">报名提交</DefaultBtn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const form = {
        // 姓名
        name: null,
        // 法名
        legalName: null,
        // 性别
        sex: null,
        // 年龄
        age: null,
        // 身份证号
        idCartNum: null,
        // 地址
        address: null,
        // 联系方式
        mobile: null,
    }
    export default {
        props: {
            pageData: Object,
            pay: {
                type: Function
            }
        },
        data () {
            return {
                form: { ...form },
                payload: this.pageData
            }
        },
        methods: {
            onPay () {
                // 表单验证
                this.$refs.form.validate().then(err => {
                    if (!err) {
                        const form = {
                            jingciOrderGuiyiUser: this.form,
                            // 法会订单
                            type: 1,
                            // 后台管理订单详情里面后到
                            orderType: JSON.stringify({
                                key: 'fawu-fahui-baoming',
                                way: 'guiyi',
                                pId: this.payload.pId
                            }),
                            // 商品id
                            categoryId: this.payload.id,
                            // 商品id
                            goodsId: this.payload.goodId,
                            // 支付类型
                            payWay: 'JSAPI',
                            orderPrice: this.payload.price,
                            goodsNum: 1
                        }
                        this.pay(form)
                    } else {
                    }
                }).catch(() => {
                    this.$toast('请填写登记信息')
                })
            }
        }
    }
</script>

<style>

</style>